import { workloadScenarioSettingsLoaded } from 'owa-scenario-settings';
import { orchestrator } from 'satcheljs';
import { updateSelectedCalendarViewInStore } from '../actions/internalActions';

export const workloadScenarioSettingsLoadedOrchestrator = orchestrator(
    workloadScenarioSettingsLoaded,
    actionMessage => {
        const { settings } = actionMessage;
        if (settings.timePanelSelectedCalendarView) {
            updateSelectedCalendarViewInStore(settings.timePanelSelectedCalendarView);
        }
    }
);
